import _classCallCheck from "/Users/hardik/Documents/projects/Hardikkhanesa.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/hardik/Documents/projects/Hardikkhanesa.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var SequentialIDGenerator = /*#__PURE__*/function () {
  function SequentialIDGenerator() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    _classCallCheck(this, SequentialIDGenerator);
    // ensure start with "ae" so "ad" is never produced
    this.prefix = prefix;
    this.count = 0;
    this.offset = 374;
    this.msb = 1295;
    this.power = 2;
  }
  _createClass(SequentialIDGenerator, [{
    key: "next",
    value: function next() {
      var id = this.increment().toString(36);
      return this.prefix ? "".concat(this.prefix).concat(id) : id;
    }
  }, {
    key: "increment",
    value: function increment() {
      var id = this.count + this.offset;
      if (id === this.msb) {
        this.offset += (this.msb + 1) * 9;
        this.msb = Math.pow(36, ++this.power) - 1;
      }
      this.count++;
      return id;
    }
  }]);
  return SequentialIDGenerator;
}();
export { SequentialIDGenerator as default };